module.exports = __webpack_public_path__ + "static/media/send-mail.2435374b.svg";